import Component from '@glimmer/component';
import { service } from '@ember/service';
import tippy from 'tippy.js';
import { action } from '@ember/object';

export default class OrganismsAccountMenuComponent extends Component {
  @service('current-user') currentUser;
  @service router;
  @service emailInvite;
  @service organisation;
  @service betaToggle;

  tippyInstance;

  get profile() {
    return this.currentUser;
  }

  @action
  menuTippy(element) {
    let tigger = element;
    let dropdown = element.querySelector('.tippy-dropdown');
    let self = this;
    this.tippyInstance = tippy(tigger, {
      content: dropdown,
      placement: 'bottom-end',
      arrow: false,
      trigger: 'click',
      interactive: true,
      offset: [0, 8],
      onShow() {
        self.isOpen = true;
      },
      onHide() {
        self.isOpen = false;
      },
    });
  }

  @action
  accountSettings() {
    this.router.transitionTo('settings.account');
    this.tippyInstance.hide();
  }

  @action
  logout() {
    this.router.transitionTo('logout');
  }

  @action
  handleInviteClick() {
    this.emailInvite.toggleInviteModal(true);
    this.tippyInstance.hide();
  }
}
